import React from 'react';
import { useIntl } from 'react-intl';
import Tag from '@amzn/meridian/tag';
import { ContactStatusOptions } from '@amzn/aet-contactrecommendation-kit';

interface StatusTagProps {
  status: ContactStatusOptions;
}

export const OutlierStatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const intl = useIntl();

  switch (status) {
    case undefined:
    case ContactStatusOptions.UNDEFINED:
      return (
        <Tag type='neutral'>
          {intl.formatMessage({
            id: 'cs_perfportal_status_tag_pending_review',
            defaultMessage: 'Pending',
          })}
        </Tag>
      );
    case ContactStatusOptions.REVIEWED:
      return (
        <Tag type='theme'>
          {intl.formatMessage({
            id: 'cs_perfportal_status_tag_reviewed',
            defaultMessage: 'Reviewed',
          })}
        </Tag>
      );
    case ContactStatusOptions.DELIVERED:
      return (
        <Tag type='success'>
          {intl.formatMessage({
            id: 'cs_perfportal_status_tag_delivered',
            defaultMessage: 'Delivered',
          })}
        </Tag>
      );
    case ContactStatusOptions.DRAFT:
      return (
        <Tag type='warning'>
          {intl.formatMessage({
            id: 'cs_perfportal_status_tag_draft',
            defaultMessage: 'Draft',
          })}
        </Tag>
      );
    default:
      return <Tag type='warning'>{status}</Tag>;
  }
};

export default OutlierStatusTag;
